var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiece3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.399,
    height: 188.957,
    viewBox: "0 0 98.399 188.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M299.18,94.5s18.4,14.069,23.811-20.563,8.654-81.167,32.465-70.345-11.9,34.632-8.654,49.781,24.578,36.547,34.632-4.327c8.118-33.009-13.212-26.887-17.316-17.316-1.624,3.791-8.654,18.4,19.484,72.512s-7.574,48.7-9.742,33.552-12.989-22.723-15.149-14.069,8.327,30.566,10.822,40.04c2.7,10.278,3.247,25.971-15.149,22.723s-16.236-12.989-28.138-7.574",
    transform: "translate(-297.965 0.014)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiece3);
export default __webpack_public_path__ + "static/media/piece-3.6de22c58e4aa0a6df667647f246e9844.svg";
export { ForwardRef as ReactComponent };